import { render, staticRenderFns } from "./UdiInfoSearch.vue?vue&type=template&id=0009afeb&scoped=true"
import script from "./UdiInfoSearch.vue?vue&type=script&lang=js"
export * from "./UdiInfoSearch.vue?vue&type=script&lang=js"
import style0 from "./UdiInfoSearch.vue?vue&type=style&index=0&id=0009afeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0009afeb",
  null
  
)

export default component.exports